import {SystemsetupList} from "./SystemsetupList";
import {SystemsetupEdit} from "./SystemsetupEdit";
import {SystemsetupCreate} from "./SystemsetupCreate";

export default {
    list: SystemsetupList,
    create: SystemsetupCreate,
    edit: SystemsetupEdit
};
